import React from 'react';
import AuthWrapper from '../components/common/authWrapper';
import { NavLink as RRNavLink } from 'react-router-dom'
import {
	Navbar,
	Nav,
	NavItem,
	NavLink,
} from 'reactstrap';
import './NavMenu.css';

function NavMenu(props:any) {
	const {
		menuItems,
		auth
	}: {
		menuItems: any
		auth: any
	} = props;

	let renderMenuItems = menuItems.map((item:any, key:any) => {
		let menuProps: { requiresActivePatient?: string, productInstanceSettingEnabled?: boolean } = {};
		if (item.requiresActivePatient) {
			menuProps.requiresActivePatient = item.requiresActivePatient;
		}

		if (item.productInstanceSettingEnabled) {
			menuProps.productInstanceSettingEnabled = item.productInstanceSettingEnabled;
		}

		return (
			<AuthWrapper key={key} requiredPermission={item.requiredPermission} requiresProductInstanceSetting={item.requiresProductInstanceSetting} isMenuItem={true} {...menuProps}>
				<NavItem>
					<NavLink tag={RRNavLink} to={item.action}>
						<h5 className="navItemText">{item.name}</h5>
					</NavLink>
				</NavItem>
			</AuthWrapper>
		);
	});
	return (
		<Navbar expand="md" className="navbar-dark nav-menu row">
			<Nav navbar>
				{renderMenuItems}
			</Nav>
		</Navbar>
	);
	
}

export default NavMenu;
